function isDebit(tran) {
    return ['IN', 'DD', 'DM'].includes(tran.docType) //90%CM as well
  }

  function isPayment(tran) {
    return tran.docType === 'PA' || tran.tranType =='RD'
  }

function isCM(tran) {
    return tran.docType === 'CM'
}

export { isDebit, isPayment, isCM }